import { render, staticRenderFns } from "./BusinessView.vue?vue&type=template&id=89ae2506&"
import script from "./BusinessView.vue?vue&type=script&lang=js&"
export * from "./BusinessView.vue?vue&type=script&lang=js&"
import style0 from "./BusinessView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports